import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDZBLo5g8GkT3VcQcVRn3gMJd6RWfmHOO0',
  },
});

Vue.component('GmapCluster', GmapCluster);

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
